webpackJsonp([230701784122435],{

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavLink = __webpack_require__(12);
	
	var _NavLink2 = _interopRequireDefault(_NavLink);
	
	var _NavLinkPlaceholder = __webpack_require__(13);
	
	var _NavLinkPlaceholder2 = _interopRequireDefault(_NavLinkPlaceholder);
	
	__webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var children = props.children;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'docs-header', id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'CLI Tutorial'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'A tutorial for learning to create your own commands'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'docs-content' },
	        _react2.default.createElement(
	          'ul',
	          { id: 'markdown-toc' },
	          _react2.default.createElement(_NavLink2.default, { title: 'Introduction', url: '/cli/tutorial/' })
	        ),
	        children
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _CLITutorial = __webpack_require__(291);
	
	var _CLITutorial2 = _interopRequireDefault(_CLITutorial);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _CLITutorial2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Overview'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Creating your own commands for the Lore CLI is a great way to expand or modify the functionality provided by the framework. In the future, this section will include a tutorial that will teach you how to do that. But in the interim, the notes below may help you get started.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'are interested'
	      ),
	      ' in creating your own commands, please consider ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/issues' },
	        'creating an issue'
	      ),
	      ' describing what you\'re trying to do, and it may even be used as foundation for the tutorial.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This section is currently considered "lower priority" in favor of adding documentation elsewhere, but docs are prioritized based on perceived value, so speaking up is a good way to improve the prioritization of this tutorial.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Creating New Commands'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The CLI has a command called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore generate generator <generator name>'
	      ),
	      ' that will create a folder pre-configured as a working plugin for the Lore CLI. You can use this as a starting point for creating your own commands.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Debugging Module Loading'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you need to debug the module loading sequence for commands, you can add a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'debugLoading'
	      ),
	      ' key in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'options'
	      ),
	      ' object of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '.lorerc'
	      ),
	      ' file.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        "generators": {\n          "language": "es5"\n        },\n        "options": {\n          "debugLoading": true\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'debugLoading'
	      ),
	      ' is true, it will print out the directory of the modules that are being loaded, which can be helpful to confirm the CLI has loaded your custom command:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      Loading absolute module: /Users/jchansen/lore/packages/lore-cli/node_modules/lore-extract-action\n      Loading absolute module: /Users/jchansen/lore/packages/lore-cli/node_modules/lore-extract-reducer\n      Loading directory module: ../../packages/lore-extract-action\n      Loading project module: lore-generate-collection\n      Loading project module: lore-generate-component\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cli-tutorial-index-js-a0dc24859e88bbc4e8f7.js